import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiInstance from '../../axiosConfig';

export const fetchConfigs = createAsyncThunk('config/fetchConfigs', async () => {
  const language = await apiInstance.get('/config/language');
  const ffs = await apiInstance.get('/config/ff');
  const configs = await apiInstance.get('/config/configs');
  const response = { ...language.data, ...ffs.data, ...configs.data };
  return response;
});

const initialState = {
  configs: { },
  isLoading: true,
  error: null,
  success: false,
  language: {},
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchConfigs.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchConfigs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.configs = action.payload;
        state.error = null;
        state.language = action.payload?.language;
      })
      .addCase(fetchConfigs.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.error;
      });
  },
});

export default configSlice.reducer;